import { render, staticRenderFns } from "./IconEstimate.vue?vue&type=template&id=447a840e"
import script from "./IconEstimate.vue?vue&type=script&lang=ts"
export * from "./IconEstimate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports